export const bookWithMeSaveEventSuccess = "ZNVau";
export const bookWithMeSaveEventFailure = "sJNwzd";
export const bookWithMeDeleteEventSuccess = "liyo6";
export const bookWithMeDeleteEventFailure = "GdqK$d";
export default {bookWithMeSaveEventSuccess,bookWithMeSaveEventFailure,bookWithMeDeleteEventSuccess,bookWithMeDeleteEventFailure};